import { trackEvent } from 'src/common/3rdParty/tracking';
import { EXTERNAL_PATHS, PATHS } from 'src/common/constants';
import captureException from 'src/common/utils/captureException';
import { sessionStore } from 'src/common/utils/storageWrapper';
import type { InquiryData } from 'src/inquiry/types';
import { v4 as uuidv4 } from 'uuid';

/**
 * For desktop width devices, is called from /pages/trips/[listing_id]/inquiry/
 * For mobile width devices, is called from /pages/trips/[listing_id]/
 */
export const sendInquiryForGuestUser = (inquiryData: InquiryData, listingId: string, returnPath: 'inquiry' | 'listing'): void => {
  try {
    const key = uuidv4();
    sessionStore.setItem(key, JSON.stringify(inquiryData));
    const nextUrl = `${PATHS.LISTING}${listingId}${PATHS.INQUIRY_SUBMIT}?sessionKey=${key}`;
    const returnUrl = returnPath === 'inquiry'
      ? encodeURIComponent(`${window.location.pathname}${window.location.search}&sessionKey=${key}`)
      : encodeURIComponent(`${PATHS.LISTING}${listingId}/?sessionKey=${key}`);
    const contactUrl = `${EXTERNAL_PATHS.INQUIRY}${listingId}/contact/?return=${returnUrl}&next=${nextUrl}`;
    window.location.href = contactUrl;
  } catch (error) {
    captureException(`Failed to read sessionStorage:, ${error}`);
  }
};

/** Should be paired with useSavedInquiry(), consider moving to hook to handle both */
export const inquirySubmitTracker = (
  inquiryData: InquiryData,
  threadId: number,
  listingLocation?: string,
  showAiSummary?: boolean,
): void => {
  trackEvent('inquiry_submit_success', {
    p1: inquiryData.preferred_date1,
    p2: inquiryData.pickup_time,
    p3: inquiryData.trip_length,
    p4: inquiryData.adults,
    p5: inquiryData.captain_required ? 'with captain' : 'self-captain',
    ...(inquiryData.occasions?.[0] ? { p6: inquiryData.occasions[0] } : {}),
    ...(inquiryData.preferred_date2 ? { p7: inquiryData.preferred_date2 } : {}),
    ...(inquiryData.preferred_date3 ? { p8: inquiryData.preferred_date3 } : {}),
    p9: showAiSummary ? 'ai_summary_visible' : 'ai_summary_hidden',
    thread_id: threadId.toString(),
    ...(listingLocation ? { listing_location: listingLocation } : {}),
  });
};
